import React from "react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {PaymentsRedirectApplication} from "../../services/casinofied/app-launcher/apps/payments-redirect/payments-redirect.application";
import {CyClass} from "../../../common/cy-classes";
import {PaymentRedirectFocusTitleBox} from "./boxes/payment-redirect-focus-title/payment-redirect-focus-title.box";
import {Button} from "../../basic-ui-components/button/base/button.component";
import {PaymentRedirectFocusBox} from "./boxes/payment-redirect-focus-container/payment-redirect-focus.box";
import {PaymentRedirectButtonContainerBox} from "./boxes/payment-redirect-button-container/payment-redirect-button-container.box";

interface PaymentsRedirectFocusComponentProps {
    redirectApp: PaymentsRedirectApplication;
}

export class PaymentsRedirectFocusComponent extends OrbitComponent<PaymentsRedirectFocusComponentProps> {

    private _renderButtonContainer(): React.ReactNode {
        return (
            <PaymentRedirectButtonContainerBox>
                <Button preset={"primary"} sizeVariant={"regular"} stroke={"none"} fullWidth>
                    {this.services.translation.translate("PAYMENTS_REDIRECT_FOCUS_CTA")}
                </Button>
            </PaymentRedirectButtonContainerBox>
        );
    }

    render() {

        const PaymentsRedirectIcon = this.services.theme.currentTheme.icons.paymentsRedirectIcon;

        return (
            <PaymentRedirectFocusBox
                className={CyClass('cy-payments-redirect-focus')}
                onClick={() => this.props.redirectApp.focus()}
            >
                <PaymentsRedirectIcon style={{color: this.services.theme.currentTheme.colors.popupIconColor}} size={3.8}/>
                <PaymentRedirectFocusTitleBox>
                    {this.services.translation.translate("PAYMENTS_REDIRECT_FOCUS_TEXT", {mftName: this.props.redirectApp.mftName})}
                </PaymentRedirectFocusTitleBox>
                {this._renderButtonContainer()}
            </PaymentRedirectFocusBox>
        );
    }
}
